<template>
  <div ref="BirthdayGift" class="text-justify transparent">
    <h1 class="text-center">{{ $t("portfolio.birthdayGift.pageLabel") }}</h1>
    <hr class="primary" />

    <h2>{{ $t("portfolio.birthdayGift.subtitleA") }}</h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.birthdayGift.paragraphA1") }}
    </p>
    <p>
      {{ $t("portfolio.birthdayGift.paragraphA2") }}
    </p>

    <h2>{{ $t("portfolio.birthdayGift.subtitleB") }}</h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.birthdayGift.paragraphB1") }}
    </p>
    <ul>
      <li v-for="(text, index) in $t('portfolio.birthdayGift.listB1')" :key="`listB1-${index}`">
        <b class="text-white-purple">{{ text }}</b>
      </li>
    </ul>
    <p>
      {{ $t("portfolio.birthdayGift.paragraphB2") }}
    </p>
    <ul>
      <li
        v-for="(text, index) in $t('portfolio.birthdayGift.listB2')"
        :key="`listB2-${index}`"
        v-html="text"
      ></li>
    </ul>

    <h2>{{ $t("portfolio.birthdayGift.subtitleC") }}</h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.birthdayGift.paragraphC1") }}
    </p>

    <h2>{{ $t("portfolio.birthdayGift.subtitleD") }}</h2>
    <hr class="secondary" />
    <p>
      {{ $t("portfolio.birthdayGift.paragraphD1") }}

      <a
        :href="$t('portfolio.birthdayGift.link')"
        class="general-anchor decorated"
        rel="noreferrer,noopener"
        target="_blank"
      >
        <span>{{ $t("portfolio.birthdayGift.linkText") }}</span> </a
      >.
    </p>
    <div class="text-center">
      <video width="auto" :height="$store.state.Global.window.height * 0.8" controls>
        <source
          :src="`${$store.state.Global.env.AWS_S3_PATH}cv/videos/birthday-gift.mp4`"
          type="video/mp4"
        />
        {{ $t("portfolio.birthdayGift.videoNotSupported") }}
      </video>
    </div>
  </div>
</template>

<script>
export default {
  name: "BirthdayGift"
};
</script>
